import React from 'react';
import { Box, Button, Typography } from '@mui/material';

// Lazy import failures are render errors, so the viewer's onError callback
// cannot catch them. Keep the boundary inside the pane: queued chat messages
// and unsaved forms outside it must survive a failed preview.
export default class ViewerErrorBoundary extends React.Component {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error, info) {
    console.error('Decode preview failed:', error, info.componentStack);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <Box role="alert" sx={{ p: 3, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
        <Typography>Decode couldn’t load this preview.</Typography>
        <Typography variant="body2" color="text.secondary">
          Save any unsent work, then reload the page to try again.
        </Typography>
        <Box sx={{ display: 'flex', gap: 1 }}>
          {this.props.onDownload && <Button onClick={this.props.onDownload}>Download</Button>}
          <Button variant="outlined" onClick={() => window.location.reload()}>Reload page</Button>
        </Box>
      </Box>
    );
  }
}
